module.exports = __webpack_public_path__ + "static/media/attachment.c5c1f404.svg";